import React, { FunctionComponent, useState } from "react";
import { Box, Stack, Typography, Container, Fade, Slide } from "@mui/material";
import styled from "styled-components";
import ExperienceIcon from "@mui/icons-material/LocalPolice";
import ProjectsIcon from "@mui/icons-material/BusinessCenter";
import AchievementsIcon from "@mui/icons-material/MilitaryTech";

import VizSensor from "react-visibility-sensor";

const containerWrapper = {

  paddingBottom: "40px",
  display: "flex",
  justifyContent: "center",
};

const stackWrapper = {
  marginTop:"150px",
  "@media (max-width: 1023px)": {
    flexDirection: "column",
    alignItems: "center",
  },
};

const InnerContainer = styled.div`

  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
`;
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconSize = {
  fontSize: "40px",
};

const Cards: FunctionComponent = () => {
  let [active, setActive] = useState(false);
  const containerRef = React.useRef(null);
  return (
    <VizSensor
      onChange={(isVisible: boolean) => {
        setActive(isVisible);
      }}
    >
      <Container sx={containerWrapper}>
        <Stack spacing={2} direction="row" sx={stackWrapper} ref={containerRef}>
          <Slide
            in={active}
            timeout={200}
            direction="left"
            container={containerRef.current}
          >
            <Box
              sx={{
                width: 300,
                height: 130,
                borderRadius: "10px",
                bgcolor: "#A37E7E",
                boxShadow: "11px 10px 38px hsla(0, 0%, 0%, 38%)",
                transition: "all 1s ease-in",
                "&:hover": {
                  backgroundColor: "primary.main",
                },
                "@media (min-width: 200px) and (max-width: 1023px)": {
                  marginLeft: "0px !important",
                  marginBottom: "20px !important",
                },
              }}
            >
              <InnerContainer>
                <ExperienceIcon sx={IconSize} />
                <ContentContainer>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "#cfcfc4" }}
                  >
                    5+
                  </Typography>
                  <Typography  sx={{  color: "#e7e4e5" }} variant="h6" gutterBottom>
                    Years of Experience
                  </Typography>
                </ContentContainer>
              </InnerContainer>
            </Box>
          </Slide>
          <Fade in={active} timeout={1000}>
            <Box
              sx={{
                width: 300,
                height: 130,
                borderRadius: "10px",
                bgcolor: "#A37E7E",
                boxShadow: "11px 10px 38px hsla(0, 0%, 0%, 38%)",
                transition: "all 1s ease-in",
                "&:hover": {
                  backgroundColor: "primary.main",
                },
                "@media (min-width: 200px) and (max-width: 1023px)": {
                  marginLeft: "0px !important",
                  marginBottom: "20px !important",
                },
              }}
            >
              <InnerContainer>
                <ProjectsIcon sx={IconSize} />
                <ContentContainer>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "#cfcfc4" }}
                  >
                    7+
                  </Typography>
                  <Typography  sx={{  color: "#e7e4e5" }}variant="h6" gutterBottom>
                    Completed Projects
                  </Typography>
                </ContentContainer>
              </InnerContainer>
            </Box>
          </Fade>
          <Slide
            in={active}
            timeout={200}
            direction="right"
            container={containerRef.current}
          >
            <Box
              sx={{
                width: 300,
                height: 130,
                borderRadius: "10px",
                bgcolor: "#A37E7E",
                boxShadow: "11px 10px 38px hsla(0, 0%, 0%, 38%)",
                transition: "all 1s ease-in",
                "&:hover": {
                  backgroundColor: "primary.main",
                },
                "@media (min-width: 200px) and (max-width: 1023px)": {
                  marginLeft: "0px !important",
                  marginBottom: "20px !important",
                },
              }}
            >
              <InnerContainer>
                <AchievementsIcon sx={IconSize} />
                <ContentContainer>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "#cfcfc4" }}
                  >
                    3
                  </Typography>
                  <Typography  sx={{  color: "#e7e4e5" }} variant="h6" gutterBottom>
                    Performance Awards
                  </Typography>
                </ContentContainer>
              </InnerContainer>
            </Box>
          </Slide>
        </Stack>
      </Container>
    </VizSensor>
  );
};

export default Cards;
